import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

import {
	$loadableDocumentOnboardingState,
	$onboardingDismissed,
} from "../../internal/document/onboarding.atom";

export const useDocumentOnboarding = (documentId: string | undefined) => {
	const docId = documentId ?? "";

	const loadableState = useAtomValue($loadableDocumentOnboardingState(docId));
	const setDismissed = useSetAtom($onboardingDismissed(docId));

	const state = loadableState.state === "hasData" ? loadableState.data : undefined;
	const isLoading = loadableState.state === "loading";

	const shouldShow =
		!!documentId && !isLoading && !!state && !state.dismissed && state.hasMissingVars;

	const dismiss = useCallback(() => {
		if (documentId) {
			setDismissed(true);
		}
	}, [documentId, setDismissed]);

	return {
		shouldShow,
		isLoading,
		environmentStatus: state?.environmentStatus ?? {},
		hasMissingVars: state?.hasMissingVars ?? false,
		dismiss,
	};
};
